export default __webpack_public_path__ + "static/media/mobile.82706c96.png";